// @flow

import * as React from 'react';
import { Button } from '@material-ui/core';
import {
  requestGoogleCode,
  requestFacebookCode,
} from '@realadvisor/auth-client';
import { Facebook } from '../../icons/facebook.js';
import { Google } from '../../icons/google.js';
import { useTheme } from '../../theme';
import { useLocale } from '../../hooks/locale';
import type { UserData } from '../../server/UserData.js';

type ButtonProps = {|
  onClick: () => void,
  children?: React.Node,
|};

type HandleProps = {|
  userData: UserData,
  redirectUri: string,
  target: '_blank' | '_self',
|};

export const handleFacebookLogin = ({
  userData,
  redirectUri,
  target,
}: HandleProps) => {
  const { origin, publicKeys } = userData;
  const redirect_back_url = new URL('/login-facebook', origin);
  redirect_back_url.searchParams.set('redirect_uri', redirectUri);
  requestFacebookCode({
    client_id: publicKeys.FACEBOOK_APP_ID,
    redirect_back_uri: redirect_back_url.toString(),
    target,
  });
};

export const FacebookButton = (props: ButtonProps): React.Node => {
  const { t } = useLocale();
  const { colors } = useTheme();
  const facebookColor = '#3b5998';
  return (
    <Button
      css={{
        backgroundColor: facebookColor,
        ':hover': {
          backgroundColor: facebookColor,
        },
      }}
      color="primary"
      startIcon={<Facebook fill={colors.white} />}
      onClick={props.onClick}
    >
      {props.children ?? t('continueWith', { service: 'Facebook' })}
    </Button>
  );
};

export const handleGoogleLogin = ({
  userData,
  redirectUri,
  target,
}: HandleProps) => {
  const { origin, publicKeys } = userData;
  const redirect_back_url = new URL('/login-google', origin);
  redirect_back_url.searchParams.set('redirect_uri', redirectUri);
  requestGoogleCode({
    client_id: publicKeys.GOOGLE_CLIENT_ID,
    redirect_back_uri: redirect_back_url.toString(),
    target,
  });
};

export const GoogleButton = (props: ButtonProps): React.Node => {
  const { t } = useLocale();
  const { colors } = useTheme();
  const googleColor = '#dd4b39';
  return (
    <Button
      css={{
        backgroundColor: googleColor,
        ':hover': {
          backgroundColor: googleColor,
        },
      }}
      color="primary"
      startIcon={<Google fill={colors.white} />}
      onClick={props.onClick}
    >
      {props.children ?? t('continueWith', { service: 'Google' })}
    </Button>
  );
};
